module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page sell-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    staticClass: "nav-label"
  }, [_vm._v("\n                Sales\n              ")])])])])], 2), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "sell-header"
  }, [_vm._v("\n              " + _vm._s(_vm.orderHistories.length) + " sales\n            ")])])])], 2), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content mt-150"
  }, [(_vm.active_tab == 'orders') ? [(!_vm.orderHistories || _vm.orderHistories.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no sales")])]) : _c('div', {
    staticClass: "relative",
    attrs: {
      "flat": ""
    }
  }, [_vm._l((_vm.orderHistories), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [(_vm.currentUser.id == order.merchant.id) ? [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative w-100"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center w-100"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar mr-3"
    }, [_c('profile-item', {
      attrs: {
        "user": order.customer,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(order.customer.username))]), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("\n                          Purchased\n                          "), _c('b', [_vm._v(" \n                            " + _vm._s(_vm._f("formatDate")(order.created_at)) + "\n                          ")])])])])]), _vm._v(" "), _c('div', [_c('v-menu', {
      staticClass: "menu-content-x",
      attrs: {
        "left": "",
        "offset-y": "",
        "nudge-top": 35,
        "nudge-left": 45
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "round": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
      staticClass: "list-class"
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('router-link', {
      staticClass: "order-detail-btn",
      attrs: {
        "to": "`/sell/order/"
      }
    }, [_vm._v("Order Details")]), _vm._v(" "), _c('a', {
      staticClass: "message-buyer-btn"
    }, [_vm._v("Message Buyer")])], 1)], 1)], 1)], 1)], 1)])])])], 1), _vm._v(" "), _vm._l((order.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "order-section"
      }, [_c('v-container', {
        staticClass: "pa-0 mt-3",
        attrs: {
          "fluid": _vm.isSidebarMini,
          "grid-list-xl": "",
          "fill-height": ""
        }
      }, [(
        _vm.activeFilterItemStatus == '' ||
        item.status == _vm.activeFilterItemStatus
      ) ? _c('v-layout', {
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        staticClass: "px-0",
        attrs: {
          "xs8": ""
        }
      }, [_c('div', {
        staticClass: "order-content-section"
      }, [_c('div', {
        staticClass: "order-content-container"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('div', {
        staticClass: "product-content-row"
      }, [_c('div', {
        staticClass: "product-name"
      }, [_vm._v("\n                                " + _vm._s(item.product.name) + " |\n                                " + _vm._s(item.product_variant.name) + "\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "product-content-row pt-1"
      }, [_c('div', {
        staticClass: "product-price"
      }, [_vm._v("\n                                $" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n                              ")])])])]), _vm._v(" "), _c('v-spacer')], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "px-0",
        attrs: {
          "xs4": ""
        }
      }, [(_vm.isDigitalProduct(item)) ? _c('div', {
        staticClass: "order-status-section text-xs-center digital"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("\n                          " + _vm._s(item.product.digital_content_name) + "\n                        ")])]) : (item.status == 'item_ordered') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Ship by 9/21/2022")]), _vm._v(" "), _c('v-btn', {
        staticClass: "order-status-btn ship",
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openShipConfirmModal(item)
          }
        }
      }, [_vm._v("Ship")])], 1) : (item.status == 'item_shipped') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Shipped")]), _vm._v(" "), _c('v-btn', {
        staticClass: "order-status-btn shipped",
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openUnshipConfirmModal(item)
          }
        }
      }, [_vm._v("Unship")])], 1) : (item.status == 'item_refunded') ? _c('div', {
        staticClass: "order-status-section text-xs-center"
      }, [_c('p', {
        staticClass: "order-status-text"
      }, [_vm._v("Refunded")])]) : _vm._e()])], 1) : _vm._e()], 1)], 1)
    })] : [_c('div', {
      staticClass: "profile-section"
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', {
      staticClass: "profile-content-section relative w-100"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center w-100"
    }, [_c('div', {
      staticClass: "dflex align-center"
    }, [_c('div', {
      staticClass: "profile-avatar mr-3"
    }, [_c('profile-item', {
      attrs: {
        "user": order.customer,
        "className": 'order-item-profile-avatar'
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "profile-content"
    }, [_c('a', {
      staticClass: "user-name",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(order.customer.username))]), _vm._v(" "), _c('label', {
      staticClass: "order-detail-text"
    }, [_vm._v("\n                          Purchased\n                          ")]), _vm._v(" "), _c('label', {
      staticClass: "order-date"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("formatDate")(order.created_at)))])])])])])])])])], 1), _vm._v(" "), _vm._l((order.items), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "order-section"
      }, [(
        _vm.activeFilterItemStatus == '' ||
        item.status == _vm.activeFilterItemStatus
      ) ? _c('div', {
        staticClass: "order-section__item"
      }, [_c('div', {
        staticClass: "order-content-section relative"
      }, [_c('div', {
        staticClass: "product-cover-image",
        style: (("background-image: url(" + (item.product.covers[0].cover.thumb.url) + ")"))
      }), _vm._v(" "), _c('div', {
        staticClass: "product-content"
      }, [_c('v-flex', {
        staticClass: "product-content-row",
        attrs: {
          "sm12": ""
        }
      }, [_c('label', {
        staticClass: "product-name"
      }, [_vm._v(_vm._s(item.product.name))])]), _vm._v(" "), _c('v-flex', {
        staticClass: "product-content-row",
        attrs: {
          "sm12": "",
          "pt-1": ""
        }
      }, [_c('label', {
        staticClass: "product-price"
      }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(item.price)))])])], 1)])]) : _vm._e()])
    })]], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.order_pagination.current_page < _vm.order_pagination.total_pages
      ),
      expression: "\n                order_pagination.current_page < order_pagination.total_pages\n              "
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadOrders()
      }
    }
  }, [_vm._v("Load More")])], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'products') ? [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) !=
    -1
  ) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [(_vm.currentUser.stripe_connected) ? _c('v-btn', {
    staticClass: "add-product-btn",
    nativeOn: {
      "click": function($event) {
        _vm.addProduct()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add Product\n              ")], 1) : _c('v-btn', {
    staticClass: "add-product-btn",
    attrs: {
      "to": "/settings#bank-details"
    }
  }, [_vm._v("\n                Connect Stripe to Add Products\n              ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.published_products), function(product, index) {
    return _c('product-item', {
      key: index,
      attrs: {
        "index": index,
        "product": product,
        "deleteItem": _vm.openProductDeleteConfirmDialog
      }
    })
  })], 2)], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'collaborations') ? [(!_vm.collaborated_products || _vm.collaborated_products.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no product collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.collaborated_products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "card-container"
    }, [_c('collaborate-product', {
      attrs: {
        "product": product,
        "editButtonAction": _vm.editProduct,
        "deleteButtonAction": _vm.openProductDeleteConfirmDialog
      }
    })], 1)
  }))], 1)] : _vm._e(), _vm._v(" "), (_vm.active_tab == 'pendings') ? [(!_vm.pending_products || _vm.pending_products.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("\n            You have no pending product collaborations\n          ")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "card-container"
    }, [(product.merchant.id == _vm.currentUser.id) ? _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false,
        "editButtonAction": _vm.editProduct,
        "deleteButtonAction": _vm.openProductDeleteConfirmDialog,
        "releaseButtonAction": _vm.releaseProduct
      }
    }) : (_vm.notResponded(product)) ? _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false,
        "acceptButtonAction": _vm.acceptCollaboration,
        "denyButtonAction": _vm.denyCollaboration
      }
    }) : _c('collaborate-product', {
      attrs: {
        "product": product,
        "showPromoteButton": false
      }
    })], 1)
  }))], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_product_finish_modal) ? _c('div', {
    staticClass: "product-finish-section"
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.closeProductFinishModal()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("This product is pending release,\n            "), _c('router-link', {
    staticClass: "link-text",
    attrs: {
      "to": "/product/add"
    }
  }, [_vm._v("upload another")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "promote-product-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "header-text"
  }, [_vm._v("What Next?")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "promote-product-image"
  }, [_c('div', {
    staticClass: "promote-image",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "promote-product-description"
  }, [_c('p', [_vm._v("\n                When you added collaborators accept your collaboration via\n                Direct Message or Sell > Pending Collaborations, you will then\n                be able to release the product.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Visit Sell > Pending Collaborations to see who accepted and/or\n                denied your collaboration.\n              ")])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.product_delete_confirm_dialog),
      callback: function($$v) {
        _vm.product_delete_confirm_dialog = $$v
      },
      expression: "product_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the product will no longer be available to users.\n          Click OK to delete <" + _vm._s(_vm.product.name) + ">, or click\n          Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteProduct()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeProductDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.show_ship_confirm_modal),
      callback: function($$v) {
        _vm.show_ship_confirm_modal = $$v
      },
      expression: "show_ship_confirm_modal"
    }
  }, [_c('v-form', {
    ref: "valid_tracking_form",
    attrs: {
      "lazy-valiation": ""
    },
    model: {
      value: (_vm.valid_tracking_form),
      callback: function($$v) {
        _vm.valid_tracking_form = $$v
      },
      expression: "valid_tracking_form"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Ship Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Enter shipping carrier website & tracking number"), _c('br'), _vm._v("\n            Buyer will see the tracking number in their "), _c('b', [_vm._v("Order History")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "www.fedex.com",
      "rules": [function (v) { return !!v || 'Carrier website is required'; }],
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.tracking_site),
      callback: function($$v) {
        _vm.tracking_site = $$v
      },
      expression: "tracking_site"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Enter tracking number",
      "rules": [function (v) { return !!v || 'Tracking number is required'; }],
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.tracking_number),
      callback: function($$v) {
        _vm.tracking_number = $$v
      },
      expression: "tracking_number"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.shipItem()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeShipConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.show_unship_confirm_modal),
      callback: function($$v) {
        _vm.show_unship_confirm_modal = $$v
      },
      expression: "show_unship_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Unship Product")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the buyer will see the item has not been shipped.\n          Click OK to mark the itme as unshipped, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.unshipItem()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeUnshipConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-2"
    },
    model: {
      value: (_vm.show_help_dialog),
      callback: function($$v) {
        _vm.show_help_dialog = $$v
      },
      expression: "show_help_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('label', [_vm._v("Sellers")])]), _vm._v(" "), _c('v-card-text', [_c('ul', [_c('li', [_vm._v("Sell "), _c('b', [_vm._v("physical")]), _vm._v(" & "), _c('b', [_vm._v("digital")]), _vm._v(" products.")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Collaborate")]), _vm._v(" on products with artists, brands & labels.\n            ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Set splits & recoup costs")]), _vm._v(", confirm through direct message.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Automatically "), _c('b', [_vm._v("split payments")]), _vm._v(" for collaborative products.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Keep"), _c('b', [_vm._v(" 90%")]), _vm._v(" of sales.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelpDialog()
      }
    }
  }, [_vm._v("Ok, Got it!")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51578858","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/sell.vue
// module id = 1721
// module chunks = 180